module.exports = __webpack_public_path__ + "static/media/28.392d4d50.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/28.png
// module id = 1402
// module chunks = 0